export const ASSET_APP_IDS = {
  TABLES: "TableCLIAPI",
  INTERFACES: "InterfacesCLIAPI",
  CHATBOTS: "ChatbotsCLIAPI",
} as const;
